import { Link } from "react-router-dom";

export function LogoMark({ className = "h-9 w-9", light = false }) {
  return (
    <svg viewBox="0 0 40 40" className={className} aria-hidden="true">
      <rect width="40" height="40" rx="12" fill={light ? "#FFFFFF" : "#4F0341"} />
      <circle cx="20" cy="20" r="11" fill="none" stroke={light ? "#4F0341" : "#F3E8F1"} strokeOpacity="0.45" strokeWidth="1.5" />
      <path d="M20 8 L23.2 20 L20 32 L16.8 20 Z" fill={light ? "#4F0341" : "#FFFFFF"} />
      <path d="M20 8 L23.2 20 L16.8 20 Z" fill="#D97706" />
    </svg>
  );
}

export default function Logo({ light = false, to = "/", testId = "brand-logo-link" }) {
  return (
    <Link to={to} data-testid={testId} className="inline-flex items-center gap-2.5 group">
      <LogoMark light={light} className="h-9 w-9 transition-transform duration-300 group-hover:rotate-12" />
      <span className="flex flex-col leading-none">
        <span className={`font-display text-2xl font-extrabold tracking-tight ${light ? "text-white" : "text-[#1C111A]"}`}>Disha</span>
        <span className={`text-[10px] font-semibold tracking-wide ${light ? "text-white/60" : "text-[#635060]"}`}>by CampusSaarthi</span>
      </span>
    </Link>
  );
}
